import {createHandlerChainRunnerOptionalParameter, HasOnError,HasOnSuccess,} from "@insite/client-framework/HandlerCreator";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import {getInventoryEDD, InventoryEDDParams,InventoryEDDModal} from "@NA/Services/ADIGetInventoryEDD";

type HandlerType = CustomApiHandler<InventoryEDDParams & HasOnSuccess & HasOnError, InventoryEDDModal>;

export const DispatchBeginLoadEDD: HandlerType = props => {
    props.dispatch({
        type: "Custom/BeginLoadInventoryEDD",
        parameter: props.parameter,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getInventoryEDD(
        { 
            Item:props.apiParameter.Item, 
            DestinationZipCode:props.apiParameter.DestinationZipCode,
            Weight: props.apiParameter.Weight
        });
};

export const DispatchCompleteLoadEDD: HandlerType = props => {
    if (props.apiResult) {
        props.parameter.onSuccess?.(props.apiResult as any);
        props.dispatch({
            type: "Custom/CompleteInventoryEDD",
            InventoryEDDData: props.apiResult,
        });
    }
};

export const chain = [DispatchBeginLoadEDD, PopulateApiParameter, RequestDataFromApi, DispatchCompleteLoadEDD];

const customLoadInventoryEDD = createHandlerChainRunnerOptionalParameter(
    chain,
    {
        Item: "",
        DestinationZipCode:"",
        Weight:""
    },
    "customLoadInventoryEDD",
);
export default customLoadInventoryEDD;
